import { render, staticRenderFns } from "./sugestoes-de-exemplo.vue?vue&type=template&id=451aa298&scoped=true&"
import script from "./sugestoes-de-exemplo.vue?vue&type=script&lang=js&"
export * from "./sugestoes-de-exemplo.vue?vue&type=script&lang=js&"
import style0 from "./sugestoes-de-exemplo.vue?vue&type=style&index=0&id=451aa298&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451aa298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451aa298')) {
      api.createRecord('451aa298', component.options)
    } else {
      api.reload('451aa298', component.options)
    }
    module.hot.accept("./sugestoes-de-exemplo.vue?vue&type=template&id=451aa298&scoped=true&", function () {
      api.rerender('451aa298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/sugestoes-de-exemplo/sugestoes-de-exemplo.vue"
export default component.exports